module.exports = __webpack_public_path__ + "static/mobile-1a5f82142ae91ca3d4df3c02060540f9.png";